const SHIPMENT_TYPES = [
    {
        label: 'Shorthaul',
        value: 'shorthaul',
    },
    {
        label: 'Longhaul',
        value: 'longhaul',
    },
    {
        label: 'Dayrate',
        value: 'dayrate',
    },
];
export const RAIL = 'rail';
export const DRAYAGE = 'drayage';
export const INTERMODAL_TYPES = [DRAYAGE, RAIL];
export const SHORTHAUL_SHIPMENT_GROUP = ['shorthaul', 'longhaul', 'dayrate'];
export const SHIPMENT_STATUS_MAPPING = {
    NEEDS_APPT: 'needs_appt',
};
export default SHIPMENT_TYPES;
